import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FsLightbox from 'fslightbox-react';

const WelcomeOne = ( props ) => { 

    const [toggler, setToggler] = useState( false );
    const videoLink = [
        props.videoLink || 'https://www.youtube.com/watch?v=pNje3bWz7V8'
    ];
    
    return(
        <>
        <section className="about-section section-padding-one">
            <div className="default-container">
                <div className="row clearfix">

                    <div className="o-title-column col-lg-6">
                        <div className="sec-o-title">
                            <div className="o-title-text">Welcome</div>
                            <h2 className="transform-uppercase">25 YEARS <span>EXPERIENCE IN THIS FIELD</span></h2>
                        </div>
                        <div className="text">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            Duis aute irure dolor in reprehen derit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</div>
                        <Link to="#" className="o-btn btn-style-one">More</Link>
                    </div>

                    <div className="o-video-col col-lg-6">
                        <div className="inner-column">

                            <div className="video-holder">
                                <figure className="image">
                                    <img src="images/background/play-01.png" alt="play" />
                                </figure>
                                <button className={`overlay-holder ${ props.linkClass ? props.linkClass : '' }` } onClick={ () => setToggler( ! toggler ) }><span className="flaticon-play-button-1"></span></button>
                                <FsLightbox 
                                    toggler={ toggler } 
                                    sources={ videoLink }
                                    maxYoutubeVideoDimensions={ { width: 900, height: 550 } }
                                />
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
        </>
    )
}

export default WelcomeOne;